import {
  Form,
  DatePicker,
  Input,
  Row,
  Col,
  Select,
  Card,
  message,
  Badge,
  Radio,
} from "antd";
import React, { useEffect, useState, useCallback } from "react";
import { Button, Checkbox, InputNumber } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "antd/es/form/Form";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Option } from "antd/es/mentions";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import {
  getLabel,
  isArrayNonEmpty,
  isValidElement,
  isValidString,
} from "../../util/ApiHelper";
import { MY_EXIM_API_RFQ } from "../../appRedux/services/requestQuotationsNetwork";
import { BUSINESS_TYPE_FOR_MESSAGE, RFQStatus } from "../../util/Constant";
import Upload from "../../components/Upload";
import {
  isCHA,
  isManufacturer,
  isShippingLine,
  showAlert,
} from "../../util/helper";
import { labelComponent } from "../../util/UtilComponents";
import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { LeftOutlined } from "@ant-design/icons";
import { fetchError, fetchStart, fetchSuccess } from "../../appRedux/actions";
import {
  isEnquiryPublished,
  isBuyer,
  isExporter,
  isManufacturerCumExporter,
} from "../../util/helper";
import { BUSINESS_TYPE } from "../../util/Constant";
import { CustomSuccessMessage } from "../../util/CustomMessage";
import { startCase } from "lodash";
import { getProductsAction } from "../../appRedux/actions/myProductsAction";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";

const { TextArea } = Input;

const shipmentTypes = [
  { label: "FCL (Full Container Load)", value: "fcl" },
  { label: "LCL (Less Container Load)", value: "lcl" },
];
const MyForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [form] = useForm();
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const authUser = useSelector(({ auth }) => auth.userData);
  const productList = useSelector((state) => state.myProducts.productsList);

  const [submitting, setSubmitting] = useState(false);
  const [fullPageLoading, setFullPageLoading] = useState(false);

  const [fileList, setFileList] = useState([{ src: "" }]);
  const [hsCodeData, setHsCodeData] = useState(null);
  const [hsCodeId, setHsCodeId] = useState(null);

  const [selectedSourceCountry, setSelectedSourceCountry] = useState(
    isBuyer(authUser) || isExporter(authUser) || isManufacturerCumExporter(authUser) ? "India" : null
  );
  const [sourcePortsData, setSourcePortsData] = useState(null);
  const [selectedDestinationCountry, setSelectedDestinationCountry] =
    useState(null);
  const [destinationPortsData, setDestinationPortsData] = useState(null);

  const [noOfContainers, setNoOfContainers] = useState(1);

  const categoryList = useSelector((state) => state.myProducts.categoryList);
  const hsCodeList = useSelector((state) => state.myProducts.hsCodeList || []);
  const countries = useSelector(({ common }) => common.countries);
  const ports = useSelector(({ common }) => common.ports);
  const [targetedBusinessType, setTargetedBusinessType] = useState(null);

  const [filteredHsCodeData, setFilteredHsCodeData] = useState(null);

  const includeCommissionAgent = Form.useWatch("includeCommisionAgent", form);

  const uniqueProductRows = Array.from(
    new Map(
      (productList?.rows || [])
        .filter((option) => option.status === RFQStatus.APPROVED)
        .map((item) => [item?.categories?.id, item])
    ).values()
  );

  const uniqueCategoryList = Array.from(
    new Map((categoryList || []).map((item) => [item.id, item])).values()
  );

  const productsUnitList = useSelector(
    ({ myProducts }) => myProducts.productsUnitList || []
  );

  const uniqueProductsUnitList = Array.from(
    new Map(
      (productsUnitList || []).filter(Boolean).map((item) => [item.label, item])
    ).values()
  );

  const [RFQFormStatus, setRFQFormStatus] = useState(null);
  const location = useLocation();
  const path = location.pathname;
  const hasCloneParam = path.includes("clone");
  const { loading } = useSelector(({ common }) => common);
  const isCHABusinessType =
    targetedBusinessType?.[0] === BUSINESS_TYPE.CUSTOM_HOUSE_AGENT;
  const isFFBusinessType =
    targetedBusinessType?.[0] === BUSINESS_TYPE.FREIGHT_FORWARDER;
  const isShippingLineBusinessType =
    targetedBusinessType?.[0] === BUSINESS_TYPE.SHIPPING_LINE;

  const setDataToForm = useCallback(
    (data) => {
      form.setFieldsValue({
        productCategory: data?.categories.id,
        hsCode: data?.hscode.code ?? "",
        productName: data?.productName,
        quantityRequired: data?.qty,
        uom: data?.units,
        productSpecification: data?.description,
        parties: data?.targetedBusinessType?.[0],
        paymentTerms: data?.paymentTerms,
        locationForDelivery: data?.locationForDelivery,
        includeCommisionAgent: data?.includesCommisionAgent,
      });

      setHsCodeId(data?.hsCodeId);
      setSelectedDestinationCountry(data?.destinationCountry);
      setSelectedSourceCountry(data?.sourceCountry);
      if (
        data?.productImages?.length < 4 &&
        !isEnquiryPublished(RFQFormStatus)
      ) {
        const images = data?.productImages;
        images.push({ src: "" });
        setFileList([...images]);
      } else if (isArrayNonEmpty(data?.productImages)) {
        setFileList([...data?.productImages]);
      }
    },
    [RFQFormStatus, form]
  );

  useEffect(() => {
    if (isBuyer(authUser) || isExporter(authUser)|| isManufacturerCumExporter(authUser)) {
      form.setFieldValue("sourceCountry", "India");
      setTargetedBusinessType([
        ...[BUSINESS_TYPE.EXPORTER,BUSINESS_TYPE.MANUFACTURER_EXPORTER],
      ]);
    }
  }, [authUser]);

  useEffect(() => {
    if (!isArrayNonEmpty(productList)) {
      dispatch(getProductsAction());
    }
  }, [dispatch]);

  useEffect(() => {
    if (isValidElement(id)) {
      dispatch(fetchStart());
      MY_EXIM_API_RFQ.getRequestQuotationDetails({ id })
        .then((response) => {
          setDataToForm(response?.data?.data);
          setTargetedBusinessType([
            ...response?.data?.data?.targetedBusinessType,
          ]);
          setRFQFormStatus(response?.data?.data?.status);
          dispatch(fetchSuccess());
        })
        .catch((e) => {
          showAlert(e?.message);
          dispatch(fetchSuccess());
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const paymentTerms = Form.useWatch("paymentTerms", form);
  const parties = Form.useWatch("parties", form);
  const shipmentMode = Form.useWatch("shipmentMode", form);
  const shipmentType = Form.useWatch("shipmentType", form);

  useEffect(() => {
    if (
      targetedBusinessType?.[0] === BUSINESS_TYPE.FREIGHT_FORWARDER ||
      targetedBusinessType?.[0] === BUSINESS_TYPE.SHIPPING_LINE ||
      targetedBusinessType?.[0] === BUSINESS_TYPE.CUSTOM_HOUSE_AGENT
    ) {
      form.setFieldValue("shipmentMode", "sea");
      form.setFieldValue("shipmentType", "fcl");
    }
  }, [targetedBusinessType?.[0]]);

  let isEditDisabled = false;
  let isEdit = !hasCloneParam && isValidElement(id);

    const onFinish = async (values, isDraftClick = false) => {
    setSubmitting(true);
    setFullPageLoading(true);
    try {
      let formData = isDraftClick ? form?.getFieldsValue() : values;
      console.log("formData", formData);

      const targetedBusinessTypes = formData.includeCommisionAgent
        ? [BUSINESS_TYPE.MANUFACTURER, BUSINESS_TYPE.COMMISSION_AGENT, BUSINESS_TYPE.MANUFACTURER_EXPORTER]
        : [BUSINESS_TYPE.MANUFACTURER, BUSINESS_TYPE.MANUFACTURER_EXPORTER];

      let data = {
        productName: formData?.productName,
        description: formData?.productSpecification || "",
        qty: parseInt(formData?.quantityRequired) || "",
        categoryId: parseInt(formData?.productCategory),
        hsCodeId: hsCodeId,
        units: formData?.uom,
        isDuplicate: hasCloneParam,
        businessTypeId: authUser?.businessTypeId,
        userId: authUser?.id,
        status: isDraftClick ? RFQStatus?.DRAFT : RFQStatus?.PENDING_APPROVAL,
        productImages: [...fileList.filter((file) => file?.src)],
        targetedBusinessType: targetedBusinessTypes,
        paymentTerms: formData?.paymentTerms,
        locationForDelivery: formData?.locationForDelivery,
        includeCommisionAgent: formData?.includeCommisionAgent,
      };
      
      await updatedDetailsToNetwork(data);
    } catch (error) {
      message.error("Failed to submit form");
    } finally {
      setSubmitting(false); 
      setFullPageLoading(false);
    }
  };

  const onUpload = (data) => {
    setFileList((prevFileList) => {
      const updatedList = [...prevFileList];
      updatedList[data.index].src = data.src;
      if (updatedList.length < 4) {
        updatedList.push({ src: "" });
      }
      updatedList[data.index].originalName = data.originalName;
      return [...updatedList];
    });
  };
  const onRemove = (data) => {
    setFileList((prevFileList) => {
      const updatedList = [...prevFileList];
      updatedList[data.index].src = "";
      return updatedList;
    });
  };

  const updatedDetailsToNetwork = (data) => {
  return new Promise((resolve, reject) => {
    let url = isEdit
      ? `${BASE_API_CONFIG.baseURL}/enquiries/${id}`
      : `${BASE_API_CONFIG.baseURL}/enquiries`;
    
    axiosInstance
      .post(url, data)
      .then((r) => {
        let quoteSendTo =
          BUSINESS_TYPE_FOR_MESSAGE[data?.targetedBusinessType[0]] ??
          "Exporters";
        if (data?.status !== RFQStatus.DRAFT) {
          message?.success({
            duration: 10,
            icon: <></>,
            content: (
              <CustomSuccessMessage
                title={`Your Enquiry is Submitted for Authorization.`}
                message={`You will start getting the Quotations directly from ${quoteSendTo} after your Enquiry is Authorized. We will notify you when ${quoteSendTo} sends the Quotations.`}
              />
            ),
            className: "custom-success-message",
          });
        }
        history.goBack();
        resolve(r);
      })
      .catch((e) => {
        message.error(e.message);
        reject(e);
      });
  });
};

  const uploadComponent = (isDisabled) => {
    return (
      <div className="attachments">
        <div className="sub-header">Attachments</div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {fileList?.length > 0 ? (
            fileList.map((file, index) => (
              <Upload
                key={index}
                isDisabled={isDisabled}
                index={index}
                src={file.src}
                id={index}
                label={
                  isValidString(file?.label) ? file?.label : getLabel(index)
                }
                originalName={file.originalName}
                onUpload={onUpload}
                onRemove={onRemove}
              />
            ))
          ) : (
            <div>No attachments added.</div>
          )}
        </div>
      </div>
    );
  };
  const handleChangeProductCategory = (value) => {
    form.resetFields(["hsCode"]);
    setHsCodeId(null);
    setFilteredHsCodeData(null);
    setHsCodeData(hsCodeList?.filter((item) => item?.categories?.id === value));
  };

  useEffect(() => {
    const countryId = countries.find(
      (item) => item.country === selectedSourceCountry
    )?.id;
    const uniquePorts = Array.from(
      new Map(
        ports
          .filter((item) => item.countryId === countryId)
          .map((item) => [item.port, item])
      ).values()
    );
    setSourcePortsData(uniquePorts);
  }, [countries, ports, selectedSourceCountry]);

  const handleChangeSourceCountry = (value) => {
    setSelectedSourceCountry(value);
    form.resetFields(["sourcePort"]);
  };

  useEffect(() => {
    const countryId = countries.find(
      (item) => item.country === selectedDestinationCountry
    )?.id;
    setDestinationPortsData(
      ports.filter((item) => item.countryId === countryId)
    );
  }, [countries, ports, selectedDestinationCountry]);

  

  const handleHSCodeSearch = (value) => {
    const trimmedValue = value.trim();
    const containsNumbers = /^\d+$/.test(trimmedValue.toLowerCase());

    setFilteredHsCodeData(() => {
      const filterFunction = (option) => {
        const codeString = option.code
          .toString()
          .replace(/\s+/g, "")
          .toLowerCase();
        const descriptionString = option.description
          .replace(/[\n\r"]/g, "")
          .toLowerCase();

        return containsNumbers
          ? codeString.includes(trimmedValue.toLowerCase())
          : descriptionString.includes(trimmedValue.toLowerCase());
      };

      return isValidElement(hsCodeData)
        ? hsCodeData.filter(filterFunction)
        : hsCodeList?.filter(filterFunction);
    });
  };



  const validateTextArea = (_, value) => {
    if (value && value.length > 1000) {
      return Promise.reject(
        new Error("Product Requirements cannot exceed 1000 characters")
      );
    }
    return Promise.resolve();
  };

 const showExmillLocation =
    (parties === BUSINESS_TYPE.MANUFACTURER ||
      parties === BUSINESS_TYPE.COMMISSION_AGENT) &&
    (paymentTerms == "EXW" || paymentTerms == "EXM");
 
  return (
    !loading && (
          <div style={{ position: "relative" }}>
            {/* Overlay spinner */}
      {fullPageLoading && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.7)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <LoadingOutlined style={{ fontSize: 40, color: "#1890ff" }} spin />
  </div>
)}

      <Card className="myexim-detail-card">
        <div className="myexim-table-title">
          <LeftOutlined
            // className={"back-icon"}
            style={{ fontSize: "20px", color: "#434E5B" }}
            size="large"
            onClick={() => {
              history.goBack();
            }}
          />
          {isEnquiryPublished(RFQFormStatus) && !hasCloneParam
            ? "Enquiry Details"
            : isEdit
            ? "Edit Enquiry"
            : "Create Enquiry"}
        </div>

        <Form form={form} onFinish={onFinish} initialValues={{ currency: "USD",includeCommisionAgent:true }} className="gx-pt-4" >
        <Row gutter={16}>
            <Col xs={24} sm={12} md={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Product Name"
                name="productName"
                rules={[
                  { required: true, message: "Product name is required" },
                ]}
              >
                <Input
                  disabled={isEditDisabled}
                  placeholder="Enter service name"
                  size="large"
                  showCount
                  maxLength={100}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={12}>
                            <Form.Item
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              label={labelComponent(
                                "Product Category",
                                `Products Categories displayed here is based on Approved Products under My Products.`
                              )}
                              name="productCategory"
                              rules={[
                                {
                                  required: true,
                                  message: "Product Category is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                size="large"
                                name={"productCategory"}
                                placeholder="Select Product Category"
                                disabled={isEditDisabled}
                                getPopupContainer={(trigger) => trigger.parentNode}
                                onChange={handleChangeProductCategory}
                                dropdownStyle={{ maxHeight: "200px", overflowY: "auto" }}
                                filterOption={(input, option) => {
                                  const children = option?.children ?? "";
                                  const optionText = children.props?.children ?? "";
                                  return optionText
                                    .toLowerCase()
                                    .includes(input.toLowerCase());
                                }}
                              >
                              {!isBuyer(authUser)
                                ? uniqueProductRows.map((option) => (
                                    <Select.Option
                                      key={option.id}
                                      value={option?.categories?.id}
                                    >
                                      <div style={{ whiteSpace: "normal" }}>
                                        {startCase(option?.categories?.name)}
                                      </div>
                                    </Select.Option>
                                  ))
                                : uniqueCategoryList.map((option) => (
                                    <Select.Option key={option.id} value={option.id}>
                                      <div style={{ whiteSpace: "normal" }}>
                                        {option.name.charAt(0).toUpperCase() +
                                          option.name.slice(1).toLowerCase()}
                                      </div>
                                    </Select.Option>
                                  ))}
                                  </Select>
                            </Form.Item>
                          </Col>


                          <Col xs={24} sm={12} md={12}>
                                          <Form.Item
                                            disabled={isEditDisabled}
                                            labelCol={{ span: 24 }}
                                            wrapperCol={{ span: 24 }}
                                            label={labelComponent(
                                              "HS Code / Item Description",
                                              isCHABusinessType
                                                ? "Select appropriate HS Code to get the Quotation from Right Partiers."
                                                : `If you are not aware of Product Category and HS Code, Please refer DGFT website https://www.dgft.gov.in/CP/ and look for "Select your ITC(HS) Code / Product Selection".`
                                            )}
                                            help={labelComponent(
                                              <span style={{ color: "#1677ff" }}>
                                                Note: We are not responsible for any country-specific
                                                restrictions for the selected product; please ensure you
                                                review Source and Destination country’s regulations before
                                                making an inquiry
                                              </span>
                                            )}
                                            name="hsCode"
                                            rules={[
                                              {
                                                required: true,
                                                message: "HS code is required",
                                              },
                                            ]}
                                          >
                                            <Select
                                              showSearch
                                              size="large"
                                              name="hsCode"
                                              placeholder="Select HS code / Item Description"
                                              filterOption={false}
                                              dropdownStyle={{ maxHeight: "200px", overflowY: "auto" }}
                                              getPopupContainer={(trigger) => trigger.parentNode}
                                              disabled={isEditDisabled}
                                              onChange={(value) => {
                                                setHsCodeId(value);
                                              }}
                                              onSearch={handleHSCodeSearch}
                                            >
                                              {isValidElement(filteredHsCodeData)
                                                ? filteredHsCodeData?.map((option) => (
                                                    <Option key={option.id} value={option.id}>
                                                      <div style={{ whiteSpace: "normal" }}>
                                                        {option.code} -{" "}
                                                        {option.description.replace(/[\n\r"]/g, "")}
                                                      </div>
                                                    </Option>
                                                  ))
                                                : hsCodeData?.map((option) => (
                                                    <Option key={option.id} value={option.id}>
                                                      <div style={{ whiteSpace: "normal" }}>
                                                        {option.code} -{" "}
                                                        {option.description.replace(/[\n\r"]/g, "")}
                                                      </div>
                                                    </Option>
                                                  ))}
                                            </Select>
                                          </Form.Item>
                                        </Col>


                             <Col xs={24} sm={12} md={6}>
                                            <Form.Item
                                              disabled={isEditDisabled}
                                              labelCol={{ span: 24 }}
                                              wrapperCol={{ span: 24 }}
                                              label={labelComponent("Quantity Required", null)}
                                              name="quantityRequired"
                                              rules={[
                                                {
                                                  required: true,
                                                  message: "Quantity is required",
                                                },
                                              ]}
                                            >
                                              <Input
                                                disabled={isEditDisabled}
                                                placeholder="Required Quantity"
                                                size={"large"}
                                                type="number"
                                              />
                                            </Form.Item>
                                          </Col>


            <Col xs={24} sm={12} md={6}>
                            <Form.Item
                              disabled={isEditDisabled}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              label={labelComponent("Unit of Measurement (UOM)", null)}
                              name="uom"
                              rules={[
                                {
                                  required: true,
                                  message: "UOM is required",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                size="large"
                                placeholder="Select Unit of Measurement"
                                disabled={isEditDisabled}
                                getPopupContainer={(trigger) => trigger.parentNode}
                              >
                                {uniqueProductsUnitList?.map((option) => (
                                  <Option key={option.label} value={option.label}>
                                    {option.label}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>

      
          </Row>

          <Row>
  {/* Delivery Terms Section */}
  {  (
    <Col xs={24} sm={12} md={12}>
      <Form.Item
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        label={"Delivery Terms"}
        name="paymentTerms"
        rules={[
          {
            required: true,
            message: "Delivery Terms is required",
          },
        ]}
      >
        <Select
          getPopupContainer={(trigger) => trigger.parentNode}
          placeholder="Select Delivery Term"
        >
          <Option value={"EXW"}>EXW - Ex Works</Option>
          <Option value={"EXM"}>EXM - Ex Mill</Option>
          <Option value={"FOR"}>FOR</Option>
        </Select>
      </Form.Item>
    </Col>
   )}
  
  {/* Location Input - Shows based on delivery term selection */}
  {(paymentTerms === "EXW" || paymentTerms === "EXM" || paymentTerms === "FOR") && 
    (
    <Col xs={24} sm={12} md={12}>
      <Form.Item
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.paymentTerms !== currentValues.paymentTerms
        }
        disabled={isEditDisabled}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        label={labelComponent(
          paymentTerms === "FOR" 
            ? "Location for delivery" 
            : "Exmill Location"
        )}
        name="locationForDelivery"
        rules={[
          {
            validator: validateTextArea,
          },
          {
            required: true,
            message: "location for delivery is required",
          },
        ]}
      >
        <TextArea
          disabled={isEditDisabled}
          placeholder={
            paymentTerms === "FOR"
              ? "Provide the location for delivery, so that suppliers can send appropriate quotations"
              : "Enter the required Ex Works / Ex Mill location"
          }
          showCount
          maxLength={250}
        />
      </Form.Item>
    </Col>
  )}
</Row>


          <Row>
            <Col span={24}>
              <Form.Item
                disabled={isEditDisabled}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Additional Requirements"
                name="productSpecification"
                rules={[
                  { validator: validateTextArea },
                  { required: true, message: "Requirements are required" },
                ]}
              >
                <TextArea
                  rows={6}
                  placeholder="Provide any additional requirements or special instructions"
                  showCount
                  maxLength={1000}
                  disabled={isEditDisabled}
                />
              </Form.Item>
            </Col>
          </Row>

           

                      <Row>
                      <Col span={24}>
              <Form.Item
                labelCol={{ span: 12 }}
                wrapperCol={{ span: 12 }}
                name="attachment"
              >
                {uploadComponent(isEdit)}
              </Form.Item>
              <Col>
                <div className="upload-tips gx-mt-4">
                  <div className="header" style={{ display: "flex" }}>
                    <InfoCircleOutlined />
                    &nbsp; Tips
                  </div>
                  <div className="desc">
                    <Badge
                      status="default"
                      text="Attach supporting documents if needed"
                    />
                    <br />
                    <Badge
                      status="default"
                      text="Supported file types: .jpg, .jpeg, .png, .pdf"
                    />
                    <br />
                    <Badge status="default" text="File must not exceed 5MB" />
                  </div>
                </div>
              </Col>
            </Col>
                      </Row>

                      <Row>
                        <Col span={24}>
                          <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
            
                            name="includeCommisionAgent"
                            valuePropName="checked"
                          >
                            <Checkbox>
                              Include Quotations from Commission Agents as well
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      </Row>
                         
          <Row className="gx-pt-5">
            <Col span={24}>
              <Form.Item className="gx-text-center">
                <div
                  className="gx-mr-3"
                  style={{
                    justifyContent: isMobile ? "center" : "end",
                    display: "flex",
                    flex: 1,
                    flexWrap: "wrap",
                    gap: "8px"
                  }}
                >
                  <Button
                    type="secondary"
                    size="large"
                    style={{ width: 200 , marginRight: isMobile ? 0 : "" }}
                    onClick={() => {
                      history.goBack();
                    }}
                  >
                    Cancel
                  </Button>
                  {!isEditDisabled &&
                    RFQFormStatus !== RFQStatus.PENDING_APPROVAL && (
                      <Button
                        type="secondary"
                        size="large"
                        style={{ width: 200, marginRight: isMobile ? 0 : ""  }}
                        onClick={() => onFinish(form, true)}
                      >
                        Save as draft
                      </Button>
                    )}
                  {!isEditDisabled && (
                    <Button
                      type="primary"
                      size="large"
                      htmlType="submit"
                      style={{ width: 200 }}
                      disabled={submitting} 
                      loading={submitting}
                    >
                      Submit
                    </Button>
                  )}
                </div>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      </div>
    )
  );
};

export default MyForm;
